/**
 * Shared interaction styles. React Aria exposes state as data attributes
 * (data-focus-visible, data-hovered, data-pressed, data-disabled …), so styles key off those.
 */
import { media } from '@planner/tokens';
import { vars } from '@planner/tokens/css';
import { style, type StyleRule } from '@vanilla-extract/css';

/** Visible keyboard focus: a ring outside the element that never shifts layout. */
export const focusRingRule: StyleRule = {
  outline: 'none',
  selectors: {
    '&[data-focus-visible]': {
      outline: `${vars.borderWidth.thick} solid ${vars.color.border.focus}`,
      outlineOffset: vars.borderWidth.thick,
    },
  },
};

export const focusRing = style(focusRingRule);

export const transition = `background-color ${vars.motion.duration.fast} ${vars.motion.easing.standard}, border-color ${vars.motion.duration.fast} ${vars.motion.easing.standard}, color ${vars.motion.duration.fast} ${vars.motion.easing.standard}, box-shadow ${vars.motion.duration.fast} ${vars.motion.easing.standard}`;

const visuallyHiddenRule: StyleRule = {
  position: 'absolute',
  width: vars.borderWidth.hairline,
  height: vars.borderWidth.hairline,
  margin: `calc(${vars.borderWidth.hairline} * -1)`,
  padding: 0,
  overflow: 'hidden',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
};

export const visuallyHidden = style(visuallyHiddenRule);

/** Hidden on narrow screens only, e.g. a button label that collapses to its icon on phones. */
export const visuallyHiddenBelowSm = style({ '@media': { [media.belowSm]: visuallyHiddenRule } });

/** Hidden below large screens, e.g. a status that keeps only its icon in a crowded header. */
export const visuallyHiddenBelowXl = style({ '@media': { [media.belowXl]: visuallyHiddenRule } });
